import * as React from 'react';
import { useEffect, useState } from 'react';

import { isNotSSR } from '@utils';

import { ReactComponent as Icon } from '../../assets/icons/arrow-top.svg';

import { ScScrollTopIcon } from './styled';

export const ScrollTopButton = () => {
	const [isVisible, setIsVisible] = useState(false);

	const toggleVisibility = () => {
		if (isNotSSR) {
			if (window.scrollY > window.innerHeight) {
				setIsVisible(true);
			} else {
				setIsVisible(false);
			}
		}
	};

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	useEffect(() => {
		window.addEventListener('scroll', toggleVisibility);
		return () => {
			window.removeEventListener('scroll', toggleVisibility);
		};
	}, []);

	return (
		<ScScrollTopIcon isVisible={isVisible} onClick={scrollToTop}>
			<Icon />
		</ScScrollTopIcon>
	);
};
